export const parseCookie = (cookie) => Object.fromEntries(cookie.split('; ').map(pair => pair.split('=')));
export const setCookie = (key, value) => {
    document.cookie = `${key}=${value}`;
    return document.cookie;
};
export const getCookie = (key) => parseCookie(document.cookie)[key];
//# sourceMappingURL=cookie.js.map